<template>
  <div class="page products-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">
      石斛系列中的三款原浆产品有独立详情页，其余系列可以在下面切换分类浏览，需要更详细的资料可以直接咨询企业顾问。
    </p>
    <ContactFriend placement="hero" />
    <ProductExplore />
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import ProductExplore from '@/components/ProductExplore.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/products.html')

export default {
  name: 'ProductsPage',
  components: {
    ContactFriend,
    ProductExplore
  },
  data() {
    return { page }
  }
}
</script>

<style scoped>
.page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

.page-intro {
  color: #333;
  line-height: 1.8;
  margin: 0 0 16px;
}
</style>
